module.exports = __webpack_public_path__ + "img/logo.f122c93e.png";